import { render, staticRenderFns } from "./ViewUserProfile.vue?vue&type=template&id=53d628e1&"
import script from "./ViewUserProfile.vue?vue&type=script&lang=js&"
export * from "./ViewUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./ViewUserProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports